import { render } from "./segmentoEditar.vue?vue&type=template&id=620105c7"
import script from "./segmentoEditar.vue?vue&type=script&lang=js"
export * from "./segmentoEditar.vue?vue&type=script&lang=js"

import "./segmentoEditar.vue?vue&type=style&index=0&id=620105c7&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__